module.exports = __webpack_public_path__ + "img/curso-online.51018d06.svg";